import { useState, useEffect } from 'react';
import { Dimensions } from 'react-native';

export enum Orientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export function useOrientation() {
  const [orientation, setOrientation] = useState<Orientation>(
    Orientation.LANDSCAPE
  );

  const determineAndSetOrientation = () => {
    const width = Dimensions.get('window').width;
    const height = Dimensions.get('window').height;

    if (width < height) {
      setOrientation(Orientation.PORTRAIT);
    } else {
      setOrientation(Orientation.LANDSCAPE);
    }
  };

  useEffect(() => {
    determineAndSetOrientation();
    const subscription = Dimensions.addEventListener(
      'change',
      determineAndSetOrientation
    );

    return () => {
      subscription.remove();
    };
  }, []);

  return { orientation };
}
